window.addEventListener('turbolinks:load', function () {
  $('.js-arera-selector__back').on('click', function () {
    var $radio = $('.js-arera-selector input[type="radio"]')
    $radio.removeAttr('checked').prop('checked', false).change()
  })
})
